import {prefixedExternalUrl} from '../../../directives/external-link';

class MainNewsItemController {
  constructor($window) {
    'ngInject';
    if (!this.selectedNews.content) {
      $window.open(prefixedExternalUrl(this.selectedNews.url), '_blank');
    }
  }
}

export default MainNewsItemController;



// WEBPACK FOOTER //
// ./client/app/components/news/mainNewsItem/mainNewsItem.controller.js